import { Badge } from 'react-bootstrap';

export default function StatusChip({
    bg,
    variant,
    pill,
    title,
    className = "",
    onClick,
    ...rest
}) {
    const background = bg || variant || "primary";

    return (
        <Badge
            pill={pill}
            bg={background}
            className={`fw-medium rounded-1 custom-status-chip ${className}`}
            onClick={onClick}
            style={{ cursor: onClick ? 'pointer' : 'default' }}
            {...rest}
        >
            {title}
        </Badge>
    );
}
